<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <!-- ROW 1-->
    <div class="vx-row">
       
        <div class="vx-col w-full mb-base">
          <div class="vx-row" v-if="user_role ==='admin' || user_role ==='adminMoozi' || user_role ==='manager'">

            <div class="cursor-pointer vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" @click="owners()" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="ClipboardIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.overview.total_owners || 0) )"
                :statisticTitle="$t('Inscrits')"/>
            </div>
            <div class=" vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserPlusIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.overview.total_agents || 0) )"
                :statisticTitle="$t('Agents')"/>
            </div>
            <div class="cursor-pointer vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" @click="letters()" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="FileTextIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.overview.total_letters || 0) )"
                :statisticTitle="$t('letters')"/>
            </div>
            <div class="cursor-pointer vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" @click="cards()" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CreditCardIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.overview.total_cards || 0) )"
                :statisticTitle="$t('cards')"/>
            </div>
            <div class=" vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CalendarIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.current_period.letters_last_month || 0) )"
                :statisticTitle="$t('letters_last_month')"/>
            </div>
            <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CalendarIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.current_period.letters_this_month || 0) )"
                :statisticTitle="$t('letters_this_month')"/>
            </div>
            <div class="vx-col w-full sm:w-full md:w-full lg:w-full xl:w-full" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.total || 0) )"
                :statisticTitle="$t('total')"/>
            </div>
            <div class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.rate_70_percent || 0) )"
                :statisticTitle="$t('rate_70_percent')"/>
            </div>
            <div class=" vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.recipients_70_percent || 0) )"
                :statisticTitle="$t('recipients_70_percent')"/>
            </div>
            <div class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.recipients_70_children || 0) )"
                :statisticTitle="$t('recipients_70_children')"/>
            </div>
            <div class=" vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.recipients_70_spouse || 0) )"
                :statisticTitle="$t('recipients_70_spouse')"/>
            </div>
            <div class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.rate_80_percent || 0) )"
                :statisticTitle="$t('rate_80_percent')"/>
            </div>
            
            <div class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.recipients_80_percent || 0) )"
                :statisticTitle="$t('recipients_80_percent')"/>
            </div>
            <div class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.recipients_80_children || 0) )"
                :statisticTitle="$t('recipients_80_children')"/>
            </div>
            <div class=" vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.sonaged_cards.recipients_80_spouse || 0) )"
                :statisticTitle="$t('recipients_80_spouse')"/>
            </div>
           <!--<chartjs-bar-chart></chartjs-bar-chart>-->
          </div>
          
          <div class="vx-row" v-if="user_role ==='managerClient'">
            <div class="cursor-pointer vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" @click="owners()" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="ClipboardIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.owners|| 0) )"
                :statisticTitle="$t('Inscrits')"/>
            </div>
            <div class=" vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserPlusIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.agents || 0) )"
                :statisticTitle="$t('Agents')"/>
            </div>
            <div class="cursor-pointer vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" @click="letters()">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="FileTextIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.letters_stats.total_letters || 0) )"
                :statisticTitle="$t('letters_last_total')"/>
            </div>
            <div class=" vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CalendarIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.letters_stats.letters_last_month|| 0) )"
                :statisticTitle="$t('letters_last_month')"/>
            </div>
            <div class=" vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CalendarIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.letters_stats.letters_current_month|| 0) )"
                :statisticTitle="$t('letters_this_month')"/>
            </div>
            <div v-if="user_id === 11 " class="cursor-pointer vx-col w-full sm:w-full md:w-full lg:w-full xl:w-full" @click="cards()" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CreditCardIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.total_cards || 0) )"
                :statisticTitle="$t('total_Sonaged')"/>
            </div>
            <div v-if="user_id === 11 " class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.cards_70_percent || 0) )"
                :statisticTitle="$t('rate_70_percent_Sonaged')"/>
            </div>
            <div v-if="user_id === 11 " class=" vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.recipients_70_percent || 0) )"
                :statisticTitle="$t('recipients_70_percent_sonaged')"/>
            </div>
            <div v-if="user_id === 11 " class=" vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.recipients_70_children || 0) )"
                :statisticTitle="$t('recipients_70_children')"/>
            </div>
            <div v-if="user_id === 11 " class=" vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.recipients_70_spouse || 0) )"
                :statisticTitle="$t('recipients_70_spouse')"/>
            </div>
            <div v-if="user_id === 11 " class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.cards_80_percent || 0) )"
                :statisticTitle="$t('rate_80_percent_Sonaged')"/>
            </div>
            
            <div v-if="user_id === 11 " class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.recipients_80_percent || 0) )"
                :statisticTitle="$t('recipients_80_percent_sonaged')"/>
            </div>
            <div v-if="user_id === 11 " class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.recipients_80_children || 0) )"
                :statisticTitle="$t('recipients_80_children')"/>
            </div>
            <div v-if="user_id === 11 " class="vx-col w-1/4 sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.recipients_80_spouse || 0) )"
                :statisticTitle="$t('recipients_80_spouse')"/>
            </div>
          </div>

          <div class="vx-row" v-if="user_role ==='adminClient'">
            <div class="cursor-pointer vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" @click="owners()" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="ClipboardIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.owners || 0) )"
                :statisticTitle="$t('Inscrits')"/>
            </div>
            <div class=" vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserPlusIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.agents || 0) )"
                :statisticTitle="$t('Agents')"/>
            </div>
            <div class="cursor-pointer vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" @click="letters()">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="FileTextIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.letters_stats.total_letters || 0) )"
                :statisticTitle="$t('letters_last_total')"/>
            </div>
            <div class=" vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CalendarIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.letters_stats.letters_last_month|| 0) )"
                :statisticTitle="$t('letters_last_month')"/>
            </div>
            <div class=" vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CalendarIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.letters_stats.letters_current_month|| 0) )"
                :statisticTitle="$t('letters_this_month')"/>
            </div>
            <div v-if="user_id === 11 " class=" cursor-pointer vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" @click="cards()">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="CreditCardIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.total_cards || 0) )"
                :statisticTitle="$t('total')"/>
            </div>
            <div v-if="user_id === 11 " class="vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.cards_70_percent || 0) )"
                :statisticTitle="$t('rate_70_percent')"/>
            </div>
            <div v-if="user_id === 11 " class="vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.cards_80_percent || 0) )"
                :statisticTitle="$t('rate_80_percent')"/>
            </div>
            <!-- <div v-if="user_id === 11 " class=" vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.recipients_70_percent || 0) )"
                :statisticTitle="$t('recipients_70_percent_sonaged')"/>
            </div>
            <div v-if="user_id === 11 " class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.card_stats.recipients_80_percent || 0) )"
                :statisticTitle="$t('recipients_80_percent_sonaged')"/>
            </div> -->
          </div>

          <div class="vx-row" v-if="user_role ==='agent'">
          <div class="cursor-pointer vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" @click="owners()" >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ClipboardIcon"
              icon-right
              :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.overview.total_specimens || 0) )"
              :statisticTitle="$t('Inscrits')"/>
          </div>
          <div class="cursor-pointer vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" @click="letters()" >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="FileTextIcon"
              icon-right
              :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.overview.total_letters || 0) )"
              :statisticTitle="$t('letters')"/>
          </div>
          <div class="cursor-pointer vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3" @click="cards()" >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="CreditCardIcon"
              icon-right
              :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.overview.total_cards || 0) )"
              :statisticTitle="$t('cards')"/>
          </div>

          <div v-if="user_id === 11 " class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.cards_stats.cards_70_percent || 0) )"
                :statisticTitle="$t('rate_70_percent')"/>
            </div>
            <div v-if="user_id === 11 " class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2" >
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BarChartIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( ( variable_dashboard.cards_stats.cards_80_percent || 0) )"
                :statisticTitle="$t('rate_80_percent')"/>
            </div>
          </div>
       </div>
    </div> 
   <!--  <vx-card >
    <div class="card mt-4">
      <div class="card-body">
        <h4 class="mb-2">{{ $t('letters_monthly_trend_table') }}</h4>
        <table class="table-auto w-full text-center">
          <thead>
            <tr>
              <th v-for="(label, idx) in monthLabels" :key="'head-'+idx" class="px-2 py-1 border">{{ label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="(count, idx) in orderedMonthlyTrend" :key="'val-'+idx" class="px-2 py-1 border text-center">{{ count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </vx-card> -->
  <br>
 
  <chartjs-bar-chart v-if="user_role ==='admin' || user_role ==='adminMoozi' || user_role ==='manager'"></chartjs-bar-chart>
  <chartjs-bar-chart-agent v-if="user_role ==='agent'"></chartjs-bar-chart-agent>
  <chartjs-bar-chart-manger-client v-if="user_role ==='managerClient'"></chartjs-bar-chart-manger-client>
  <chartjs-bar-chart-admin-client v-if="user_role ==='adminClient'"></chartjs-bar-chart-admin-client>
  </div>
</template>

<script>


import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from '@/views/ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import ChartjsBarChart from '/src/views_moozimed/statistiqueGraph/ChartjsBarChart'
import ChartjsBarChartAgent from '/src/views_moozimed/statistiqueGraph/ChartjsBarChartAgent.vue'
import ChartjsBarChartMangerClient from '/src/views_moozimed/statistiqueGraph/ChartjsBarChartMangerClient.vue'
import ChartjsBarChartAdminClient from '/src/views_moozimed/statistiqueGraph/ChartjsBarChartAdminClient.vue'

export default {
  data () {
    return {
      user_role: '',
      user_id: 0,
      dashboardValue: false,
      showByContributors: false,
      variable_dashboard : '',
      analyticsData,
      filter_appointment:null
    }
  },

  components: {
    VueApexCharts,
    ChartjsBarChartAdminClient,
    ChartjsBarChartMangerClient,
    ChartjsBarChartAgent,
    ChartjsBarChart,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline
  },
  /* computed: {
  // ...autres computed...
    orderedMonthlyTrend () {
      if (
        !this.variable_dashboard ||
      !this.variable_dashboard.letters_analytics ||
      !this.variable_dashboard.letters_analytics.monthly_trend
      ) return []
      const months = [
        'month_1', 'month_2', 'month_3', 'month_4', 'month_5', 'month_6',
        'month_7', 'month_8', 'month_9', 'month_10', 'month_11', 'month_12'
      ]
      return months.map(m => this.variable_dashboard.letters_analytics.monthly_trend[m] || 0)
    },
    monthLabels () {
      return [
        this.$t('Jan'), this.$t('Feb'), this.$t('Mar'), this.$t('Apr'),
        this.$t('May'), this.$t('Jun'), this.$t('Jul'), this.$t('Aug'),
        this.$t('Sep'), this.$t('Oct'), this.$t('Nov'), this.$t('Dec')
      ]
    }
  }, */
  methods: {
    /*  agents () {
      this.$router.push('/Agents').catch(() => {})
    }, */

    owners () {
      this.$router.push('/Inscrits').catch(() => {})
    },

    cards () {
      this.$router.push('/Cards').catch(() => {})
    },

    letters () {
      this.$router.push('/letters').catch(() => {})
    },
    dashboard () {
      this.$vs.loading()
      this.$http.get('dashboardAdmin/')
        .then((response) => {
          this.variable_dashboard = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

    },
    dashboardRefrech () {
      this.$http.get('dashboardAdmin/')
        .then((response) => {
          this.variable_dashboard = response.data
        })
        .catch(() => {
          this.$vs.loading.close()
        })

    },
    dashboard2 () {
      this.$vs.loading()
      this.$http.get('dashboardMangerClient/')
        .then((response) => {
          this.variable_dashboard = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

    },
    dashboardRefrech2 () {
      this.$http.get('dashboardMangerClient/')
        .then((response) => {
          this.variable_dashboard = response.data
        })
        .catch(() => {
          this.$vs.loading.close()
        })

    },
    dashboard3 () {
      this.$vs.loading()
      this.$http.get('dashboardAdminClient/')
        .then((response) => {
          this.variable_dashboard = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

    },
    dashboard4 () {
      this.$vs.loading()
      this.$http.get('dashboardAgent/')
        .then((response) => {
          this.variable_dashboard = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

    },
    dashboardRefrech3 () {
      this.$http.get('dashboardAdminClient/')
        .then((response) => {
          this.variable_dashboard = response.data
        })
        .catch(() => {
          this.$vs.loading.close()
        })

    },
    dashboardRefrech4 () {
      this.$http.get('dashboardAgent/')
        .then((response) => {
          this.variable_dashboard = response.data
        })
        .catch(() => {
          this.$vs.loading.close()
        })

    }
  },
  
  created () {
    document.title = 'TransVie | PDV'
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_role = userInfo.role
    if (userInfo.branch) {
      this.user_id = userInfo.branch.corporate.id
    } else {
      this.user_id = null 
    }
    if (this.user_role === 'adminClient') {
      this.user_id = userInfo.branch.corporate.id
    }
    if (this.user_role === 'admin' || this.user_role === 'manager' || this.user_role === 'adminMoozi') {
      this.dashboard()
      this.counterInterval =  setInterval(
        function () {
          this.dashboardRefrech()
        }.bind(this), 60000)
    }
    if (this.user_role === 'managerClient') {
      this.dashboard2()
      this.counterInterval =  setInterval(
        function () {
          this.dashboardRefrech2()
        }.bind(this), 60000)
    }

    if (this.user_role === 'adminClient') {
      this.dashboard3()
      this.counterInterval =  setInterval(
        function () {
          this.dashboardRefrech3()
        }.bind(this), 60000)
    }
    if (this.user_role === 'agent') {
      this.dashboard4()
      this.counterInterval =  setInterval(
        function () {
          this.dashboardRefrech4()
        }.bind(this), 60000)
    }
  },
  destroyed () {
    clearInterval(this.counterInterval)
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
